<template>
  <Modal
    ref="modal"
    ok-text="Add"
    title="Company profile questions"
    large
    class="questions-picker-modal"
  >
    <div slot="modal-body">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div v-for="attr in leftAttrs" :key="attr.value" class="checkbox">
            <label>
              <input v-model="selected" type="checkbox" :value="attr.name" />
              <span>{{ attr.label }}</span>
            </label>
            <p v-show="showQuestions" class="question-text">
              {{ attr.name | profileAttrQuestion }}
            </p>
          </div>

          <div v-if="alreadySelectedLeftAttrs.length">
            <hr />
            <h6>Already added</h6>
            <div
              v-for="attr in alreadySelectedLeftAttrs"
              :key="attr.value"
              class="checkbox"
            >
              <label>
                <input type="checkbox" checked disabled />
                <span>{{ attr.label }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div v-for="attr in rightAttrs" :key="attr.value" class="checkbox">
            <label>
              <input v-model="selected" type="checkbox" :value="attr.name" />
              <span>{{ attr.label }}</span>
            </label>
            <p v-show="showQuestions" class="question-text">
              {{ attr.name | profileAttrQuestion }}
            </p>
          </div>

          <div v-if="alreadySelectedRightAttrs.length">
            <hr />
            <h6>Already added</h6>
            <div
              v-for="attr in alreadySelectedRightAttrs"
              :key="attr.value"
              class="checkbox"
            >
              <label>
                <input type="checkbox" checked disabled />
                <span>{{ attr.label }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="modal-footer">
      <div class="checkbox pull-left">
        <label>
          <input v-model="showQuestions" type="checkbox" />
          <span>Show complete question text</span>
        </label>
      </div>

      <TextButton class="mr-4" @click="toggleAll">
        {{ areAllAlreadySelected ? 'Deselect all' : 'Select all' }}
      </TextButton>
      <button type="button" class="btn btn-default" @click="close()">
        Close
      </button>
      <button type="button" class="btn btn-primary" @click="ok()">
        Add
      </button>
    </div>
  </Modal>
</template>

<script>
import modalMixin from '@/components/ModalMixin'
import {
  PROFILE_ATTRS,
  profileAttrQuestion,
} from '@/modules/dashboard-organizer/CompanyProfileQuestions'
import TextButton from '@/components/common/TextButton'

export default {
  components: {
    TextButton,
  },
  filters: { profileAttrQuestion },
  mixins: [modalMixin],
  props: {
    alreadySelected: { type: Array, default: () => [] },
  },
  data: () => ({
    selected: [],
    showQuestions: false,
  }),
  computed: {
    alreadySelectedSet() {
      return new Set(this.alreadySelected)
    },
    attrs() {
      return PROFILE_ATTRS.filter(
        (attr) => !this.alreadySelectedSet.has(attr.name),
      )
    },
    leftAttrs() {
      return this.attrs.filter((attr) => !isFaq(attr.name))
    },
    rightAttrs() {
      return this.attrs.filter((attr) => isFaq(attr.name))
    },
    alreadySelectedAttrs() {
      return PROFILE_ATTRS.filter((attr) =>
        this.alreadySelectedSet.has(attr.name),
      )
    },
    notSelectedYetAttrs() {
      return PROFILE_ATTRS.filter(
        (attr) => !this.alreadySelectedSet.has(attr.name),
      )
    },
    alreadySelectedLeftAttrs() {
      return this.alreadySelectedAttrs.filter((attr) => !isFaq(attr.name))
    },
    alreadySelectedRightAttrs() {
      return this.alreadySelectedAttrs.filter((attr) => isFaq(attr.name))
    },
    areAllAlreadySelected() {
      return (
        this.selected.length > 0 &&
        this.selected.length === this.notSelectedYetAttrs.length
      )
    },
  },
  methods: {
    setSelected(selected) {
      this.selected = selected
    },
    ok() {
      this.$emit('ok', this.selected)
      this.$refs.modal.close()
    },
    selectAll() {
      this.selected = this.notSelectedYetAttrs.map((attr) => attr.name)
    },
    deselectAll() {
      this.selected = []
    },
    toggleAll() {
      if (this.areAllAlreadySelected) {
        this.deselectAll()
      } else {
        this.selectAll()
      }
    },
  },
}

function isFaq(attr) {
  return /^faq_/.test(attr)
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.questions-picker-modal {
  .question-text {
    color: $grey90;
    font-size: 12px;
    margin: 0;
  }
}
</style>
